import { State } from "../../types";

export type MarkDataAsSavedAction = Readonly<{
  type: "MARK DATA AS SAVED";
}>;

export const markDataAsSaved = (state: State, _action: MarkDataAsSavedAction): State => {
  return {
    ...state,
    modified: false,
  };
};
